import { createContext, useContext, useState } from 'react';
import { Api } from '../api';
import { CircularProgress, Stack } from '@mui/material';
import T from 'src/basic-components/text';
import useAuth from 'src/hooks/useAuth';
import { useNotify } from 'src/hooks/use-notify';

const ApiContext = createContext();
const useApi = () => useContext(ApiContext);

const ApiProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();
  const notify = useNotify();
  const CoreApi = (apiName, funcName) => {
    var api = Api[apiName][funcName];

    return (...data) => {
      return new Promise((resolve, reject) => {
        setLoading(true);
        api(...data)
          .then(resolve)
          .catch((err) => {
            if (err.code === '401') {
              notify.error(err.message);
              logout();
            } else reject(new Error(err.message));
          })
          .finally(() => {
            setLoading(false);
          });
      });
    };
  };

  return (
    <>
      <ApiContext.Provider
        value={{
          CoreApi,
        }}
      >
        {loading && (
          <Stack
            flex
            flexDirection="row"
            justifyContent="center"
            sx={{ position: 'absolute', right: 0, left: 0, zIndex: 9999 }}
          >
            <Stack flex flexDirection="row " gap={1} alignItems="center" className="borderBox">
              <CircularProgress color="inherit" variant="indeterminate" size={14} />
              <T>loading</T>
            </Stack>
          </Stack>
        )}
        {children}
      </ApiContext.Provider>
    </>
  );
};

export { ApiProvider, useApi };
